import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Column } from 'seagull';
import { BillingType } from '~/components/BillModal/BillClientModal.types';
import { BillChargeClientApprovalCallout, ServiceEffectiveDateCallout, ServicePendingAmendmentCallout } from '~/components/BillModal/components/Callouts/Callouts';
import CumulativeWarningCallout from '~/components/BillModal/components/Callouts/CumulativeWarningCallout';
export function RowCallouts(param) {
    let { item, rowIndex, mode, issueDate, relationshipEffectiveDate, invoiceDateInfo, hideChargeApprovalCallout, manualServiceBilling, testIds } = param;
    if (item.type === BillingType.Charge) {
        if (hideChargeApprovalCallout || !item.charge.serviceTemplateId) return null;
        return /*#__PURE__*/ _jsx(BillChargeClientApprovalCallout, {
            issueDate: issueDate,
            invoiceDateInfo: invoiceDateInfo,
            variant: "row",
            testId: testIds.ChargeApprovalCallout(rowIndex)
        });
    }
    const service = item.fullService;
    return /*#__PURE__*/ _jsxs(Column, {
        gap: 8,
        children: [
            /*#__PURE__*/ _jsx(CumulativeWarningCallout, {
                service: service,
                issueDate: issueDate,
                manualServiceBilling: manualServiceBilling,
                relationshipEffectiveDate: relationshipEffectiveDate,
                variant: "row",
                testId: testIds.CumulativeCallout(rowIndex)
            }),
            /*#__PURE__*/ _jsx(ServicePendingAmendmentCallout, {
                service: service,
                variant: "row",
                testId: testIds.PendingAmendmentCallout(rowIndex)
            }),
            /*#__PURE__*/ _jsx(ServiceEffectiveDateCallout, {
                mode: mode,
                service: service,
                issueDate: issueDate,
                relationshipEffectiveDate: relationshipEffectiveDate,
                variant: "row",
                testId: testIds.EffectiveDateCallout(rowIndex)
            })
        ]
    });
}
